<template>
  <div class="">
    <div class="head-title">最新资讯</div>
    <nav class="navbar">
      <div class="nav-l">
        <el-select
          v-model="notice_category_id"
          placeholder="请选择公告类别"
          clearable=""
          @change="buseer"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </nav>
    <div class="">
      <div class="mine_body_bottom">
        <div class="bottom_right">
          <div class="listtow">
            <div>
              <div
                class="noneed"
                v-for="(item, index) in ddsec.data"
                :key="index"
                @click="announcements(item)"
              >
                <div>{{ item.title }}</div>
                <div>
                  <span></span>
                  <span> {{ item.addtime }} </span>
                </div>
              </div>
              <template>
                <div v-if="ddsec.total == 0">
                  <el-empty description="暂无数据"></el-empty>
                </div>
              </template>
            </div>
            <div>
              <div class="paging">
                <pagination
                  :total="ddsec.total"
                  :page.sync="listQuery.page"
                  :limit.sync="listQuery.limit"
                  :page-sizes="[10,20,50,100]"
                  @pagination="buseer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "mine",
  data() {
    return {
      title: {},
      username: {},
      tabodata: {},
      defaultProps: {
        children: "data",
        label: "name",
      },
      ddsec: {
        total: 0,
        data: []
      },
      page: {},
      notice_category_id: 7,
      options: [],
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    //  if (window.sessionStorage.getItem("title")) {
    //     let title = JSON.parse(window.sessionStorage.getItem("title"));
    //     this.title = title;
    //     var a = document.title;
    //     document.title = title[0].website + "-" + a;
    //   }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
      if (this.username.parent_id != 0) {
        this.username.parent_id = 1;
      }
    }
    this.getNoticeCategoryList();
    this.buseer();
  },
  methods: {
    buseer() {
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            scope: this.username.parent_id,
            notice_category_id: this.notice_category_id,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.ddsec = res.data.data;
        })
        .catch(function (err) {});
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleNodeClick();
    },
    handleNodeClick(data) {
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            notice_category_id: data.id,
            page: this.page,
            scope: this.username.parent_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.ddsec = res.data.data;
        })
        .catch(function (err) {});
    },
    getNoticeCategoryList() {
      this.axios
        .post(
          "/api/NoticeCategory/getNoticeCategoryList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          console.log(res);
          const d = res.data.data.data;
          d.forEach((i) => {
            i.label = i.name;
            i.value = i.id;
          });
          this.options = d;
        })
        .catch(function (err) {});
    },
    announcements(val) {
      this.$router.push({
        name: "dahomeNewest",
        query: {
          val,
        },
      });
      //  this.axios
      // .post(
      //   "/api/NoticeCategory/getNoticeCategoryList",
      //   qs.stringify({
      //     agenttoken: this.username.agenttoken,
      //   }),
      //   { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      // )
      // .then((res) => {
      //   if (res.data.msg == "登录超时") {
      //     this.$router.push("/mine");
      //   }
      //   this.tabodata = res.data.data
      // })
      // .catch(function (err) {});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node__content {
  height: 50px;
}
::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #298EDB;
  color: #fff;
}
::v-deep .el-tree-node__content {
  border-bottom: 1px solid #EEEEEE;
  color: #484848;
}
::v-deep .el-tree-node__content {
  padding: 20px;
}
::v-deep .el-tree-node__label {
  font-size: 22px;
}
.mine {
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(97, 111, 180, 0.2);
}
.mine_body {
  padding: 20px;
}
.mine_body_nav {
  background-color: #298EDB;
  line-height: 50px;
  color: #fff;
  font-size: 22px;
  padding-left: 30px;
}
.mine_body_bottom {
  width: 100%;
  display: flex;
}
.list {
  padding: 20px;
  border-bottom: 1px solid #EEEEEE;
  color: #484848;
  font-size: 20px;
}
.list:hover {
  background-color: #298EDB;
  color: #fff;
}
.listtow {
  margin-top: 20px;
  background-color: #298EDB;
  color: #fff;
}
.bottom_right {
  width: 100%;
  background-color: #F8F8F8;
}
.listto {
  width: 100%;
  padding: 20px;
  color: #1A8BE5;
  font-size: 20px;
}
.listtow {
  background-color: #fff;
}
.listtow > div:nth-child(1) {
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.noneed {
  width: 100%;
  padding: 10px 20px;
  color: #5C5C5C;
  border-bottom: 1px solid #DCDCDC;
  cursor: pointer;
  //   background-color: red;
}
.noneed:hover {
  background-color: #DCDCDC;
}
.listtow > div:nth-child(2) {
  width: 100%;
  height: 10%;
}
.noneed > div:nth-child(1) {
  margin-bottom: 10px;
}
.noneed > div:nth-child(2) {
  display: flex;
  justify-content: space-between;
}
</style>
